import type { FC } from 'react';
import ReactJson from 'react-json-view';
import { useInspectedTracker } from '../../../lib/customHooks';

export const RawTab: FC = () => {
  const inspectedTracker = useInspectedTracker();
  if (inspectedTracker == null) return <></>;

  return <ReactJson src={inspectedTracker} theme="ocean" />;
};
